<template>
    <Modal v-model="modal" :width="85" :title="title" @on-visible-change="modalTrigger($event)" :footer-hide="true">
        <Tabs :value="tabsVal">
            <TabPane label="基本信息" name="basic">
                <Form :model="basisFormData" :label-width="120" label-colon="：" class="basicForm">
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="客户全称">{{basisFormData.custName}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="客户英文名">{{basisFormData.englishName}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="法人代表">{{basisFormData.legalPerson}}</FormItem></Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="注册资金">{{basisFormData.registerCapital}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="业务范围">{{basisFormData.businessScope}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="是否上市">
                                <i-switch v-model="basisFormData.listed" size="large" :disabled="true">
                                    <span slot="open">是</span>
                                    <span slot="close">否</span>
                                </i-switch>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 24}" :xl="{ span: 12}"><FormItem label="备注">{{basisFormData.description}}</FormItem></Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="注册货币类型">{{basisFormData.currencyType}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="国家">{{basisFormData.country}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="地区">{{basisFormData.region}}</FormItem></Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="行业">{{basisFormData.industry}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="电话">{{basisFormData.phone}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="传真">{{basisFormData.fax}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="邮箱">{{basisFormData.email}}</FormItem></Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="员工数">{{basisFormData.staffCount}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="联络人">{{basisFormData.contacts}}</FormItem></Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="地址">{{basisFormData.addr}}</FormItem></Col>
                    </Row>
                </Form>
            </TabPane>
            <TabPane label="财务信息" name="finance">
                <Form :model="basisFormData" :label-width="120" label-colon="：" class="basicForm">
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="年份">
                                <Select v-model="financeYearSelect" @on-change="selectChange()">
                                    <Option v-for="item in financeDateList" :value="item.value" :key="item.value">{{ item.value }}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="总资产">{{financeDrmData.totalAssets}}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="固定资产">{{financeDrmData.fixedAssets }}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="长期资产">{{financeDrmData.longAssets}}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="负债">{{financeDrmData.liabilities}}</FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="应收账款">{{financeDrmData.accountsReceivable}}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="应付账款">{{financeDrmData.accountsPayable }}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="存货">{{financeDrmData.stoke}}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="短期借款">{{financeDrmData.shortLoan}}</FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="营业收入">{{financeDrmData.income}}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="营业成本">{{financeDrmData.cost }}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="净利润">{{financeDrmData.profit}}</FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="创建时间">{{financeDrmData.createTime}}</FormItem>
                        </Col>
                        <Col :sm="{ span: 12}" :xl="{ span: 6}">
                            <FormItem label="创建人">{{financeDrmData.username }}</FormItem>
                        </Col>
                    </Row>
                </Form>
            </TabPane>
            <TabPane label="重大事项" name="matter">
                <div class="matterTable-box">
                    <Table :columns="columns" :hight="500" :data="matterTableData" :border="true"></Table>
                </div>
                <div ref="matterPage"><Page :total="matterTabletotal" /></div>
                <CustImportantNewsDetail :newsshow="newsDetailModal.show" :newstitle="newsDetailModal.title" :newsid="newsDetailModal.id" @changeShow="changeNewsModalShow($event)"></CustImportantNewsDetail>
            </TabPane>
        </Tabs>
    </Modal>
</template>

<script>
import api from '@/api/index';
import CustImportantNewsDetail from './custImportantNewsDetail';
export default {
    name: 'custDetail',
    components: {
        CustImportantNewsDetail
    },
    props: {
        control: Boolean,
        custId: String,
        custTitle: String
    },
    data() {
        return {
            columns: [
                {
                    title: '新闻标题',
                    key: 'title'
                },
                {
                    title: '新闻类型',
                    key: 'newsType',
                    width: '120',
                    align: 'center'
                },
                {
                    title: '更新人',
                    key: 'username',
                    width: '120',
                    align: 'center'
                },
                {
                    title: '更新时间',
                    key: 'createTime',
                    width: '150',
                    align: 'center'
                },
                {
                    title: '操作',
                    width: '80',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: { size: 'small' },
                                on: {
                                    click: () => {
                                        this.newsDetailShow(params.row);
                                    }
                                }
                            }, '查看')
                        ]);
                    }
                }
            ],
            matterTableData: [],
            matterTabletotal: 0,
            modal: this.control,
            id: this.custId,
            title: this.custTitle,
            tabsVal: 'basic',
            basisFormData: {
                listed: false
            },
            financeDateList: [],
            financeData: [],
            financeYearSelect: '',
            financeDrmData: {},
            newsDetailModal: {
                show: false
            }
        };
    },
    watch: {
        control(vel, oldVel) {
            this.tabsVal = 'basic';
            this.modal = vel;
        },
        custId(vel, oldVel) {
            this.id = vel;
            this.getBasicDetail();
            this.getustImportantNews();
        },
        custTitle(vel, oldVel) {
            this.title = vel + ' 客户详情';
        }
    },
    methods: {
        async getBasicDetail() {
            let res = await api.getustDetail(this.id);
            this.financeData = res.data.financialReportList;
            this.financeDateList = [];
            for (const item in res.data.financialReportList) {
                this.financeDateList.push({ value: res.data.financialReportList[item].year });
            }
            this.basisFormData = res.data;
        },
        async getustImportantNews() {
            let res = await api.getustImportantNews(10, this.matterTabletotal, this.id);
            this.matterTableData = [];
            this.matterTabletotal = res.data.total;
            for (const item in res.data.data) {
                let tableItem = res.data.data[item];
                tableItem.username = tableItem.createUser.username;
                tableItem.createTime = tableItem.createTime.split(' ')[0];
                this.matterTableData.push(tableItem);
            }
        },
        modalTrigger(val) {
            this.$emit('changeControl', val);
        },
        selectChange() {
            for (const item in this.financeData) {
                if (this.financeData[item].year === this.financeYearSelect) {
                    this.financeDrmData = this.financeData[item];
                    this.financeDrmData.username = this.financeDrmData.createUser.username;
                    this.financeDrmData.createTime = this.formatDate(this.financeDrmData.createTime);
                }
            }
        },
        formatDate(value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + MM + '-' + d;
        },
        newsDetailShow(data) {
            console.log(this.newsDetailModal.show);
            this.newsDetailModal.show = true;
            this.newsDetailModal.title = data.title;
            this.newsDetailModal.id = data.newsID.toString();
        },
        changeNewsModalShow(val) {
            this.newsDetailModal.show = val;
        }
    }
};
</script>
<style lang="scss" scoped>
.matterTable-box {
    height: 500px;
}
</style>
<style scoped>
.basicForm >>> .ivu-form-item {
    margin-bottom: 10px;
}
</style>
